export const VIDEO_CALL_SIZES = ['S', 'M', 'L'];
